import { colorToCss, isArrayEmpty, ITypedStock, StockType, sum } from "../omnia";
import { IMmExport } from "../types";

export abstract class StockVm {

    private exports: IMmExport[];

    constructor(public stock: ITypedStock, private _stockType: StockType) {
    }

    get stockType(): StockType {
        return this._stockType;
    }

    get description(): string {
        return this.stock.Name;
    }

    get orderByDescription(): string {
        return this.stock.Name;
    }

    get icon(): string {
        return "stocks";
    }

    abstract getUnits(): string;

    abstract getImgUrl(): string;

    abstract getTooltip(): string;

    abstract getColor(): number[];

    getCssFillColor(): any {
        var cssColor = colorToCss(this.getColor());
        return { fill: cssColor };
    }

    abstract hasProduct(): boolean;

    getAvailableAmount(): number {
        return this.stock["TotalAmount"] || 0;
    }

    getExportedAmount(): number {
        const { exports } = this
        return !exports ? 0 : sum(exports, e => e.Amount);
    }

    hasExports() {
        const { exports } = this
        return !isArrayEmpty(exports)
    }

    getHeaderIconClass(): string {
        return "icon icon-" + this.icon;
    }

    getRoundingFactor(): number {
        return 1;
    }

    getBalance(): number {

        var rounding = this.getRoundingFactor();

        var balance = (this.getAvailableAmount() || 0) - (this.getExportedAmount() || 0);
        balance = Math.round(balance * rounding) / rounding;

        return balance;

    }

    setExports(exports: IMmExport[]) {
        this.exports = exports;
    }
}
